import { NarrativeCard } from './NarrativeCard';

export default NarrativeCard;
